import React from 'react';
import { Link } from 'react-router-dom';

const SingleService = (props:any) => {
    const { itemClass, Icon, Title, Desc, btnText ,linkpage } = props;
    return (
        <div className={itemClass ? itemClass : 'service-item'}>
            <div className="content-part">
                <span className="icon-part"><img src={Icon} alt="" /></span>
                <h4 className="title">
                    <Link to={linkpage}>
                        {Title ? Title : 'Online Coaching'}
                    </Link>
                </h4>
                <p className="desc">{Desc}</p>
                <Link to={linkpage}>
                    {btnText ? btnText : 'Read More'} <i className="fa fa-arrow-right"></i>
                </Link>
            </div>
        </div>
    )
}

export default SingleService